module.exports = __webpack_public_path__ + "media/images/top/icon/gray/ico_angle_right-80e197f8bd12dfb03d2030922b4167dc.svg";